<template>
  <div class="step_content">
    <h3>Укажите ваши данные</h3>
    <div class="pt-4">
      <div class="row gy-2 overflow-hidden">
        <div class="col-12">
          <div class="form-floating mb-3">
            <FloatLabel variant="on">
              <InputText id="rost" class="w-100" size="large" />
              <label for="rost">Ваш рост (см.)</label>
            </FloatLabel>
          </div>
        </div>
        <div class="col-12">
          <div class="form-floating mb-3">
            <FloatLabel variant="on">
              <InputText id="ves" class="w-100" size="large" />
              <label for="ves">Ваш вес (кг.)</label>
            </FloatLabel>
          </div>
        </div>
        <div class="col-12">
          <div class="form-floating mb-3">
            <FloatLabel variant="on">
              <InputText id="sad" class="w-100" size="large" />
              <label for="sad">Систолическое давление (верхнее)</label>
            </FloatLabel>
          </div>
        </div>
        <div class="col-12">
          <div class="form-floating mb-3">
            <FloatLabel variant="on">
              <InputText id="dad" class="w-100" size="large" />
              <label for="dad">Диастолическое давление (нижнее)</label>
            </FloatLabel>
          </div>
        </div>

        <div class="col-12">
          <div class="form-floating mb-3">
            <FloatLabel variant="on">
              <InputText id="dad" class="w-100" size="large" />
              <label for="dad">Общий холестерин (ммоль/л)</label>
            </FloatLabel>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "StepWelcome",
};
</script>

<style>
.step_content {
  /*  min-height: 100%; */
}
</style>
